export const MAXIMUM_MARGIN_SYSTEM_NAME_LENGTH = 32;
export const MINIMUM_MARGIN_SYSTEM_NAME_LENGTH = 1;
export const MINIMUM_MARGIN_SYSTEM_LEVEL_VALUE = 0;
export const MAXIMUM_MARGIN_SYSTEM_LEVEL_VALUE = 99.999;
export const MARGIN_SYSTEM_DECIMAL_REGEX = /^-?[1-9]?\d?\d((.|,)\d\d?)?$/;
export const MARGIN_SYSTEM_MAX_MARGIN_VALUE = 100000;
export const MARGIN_SYSTEM_MIN_MARGIN_VALUE = -100000;